// Sign-up prefill ($firstname, $lastname, $company on /profile?email=...) has to survive the email code step,
// so it waits in sessionStorage under one key until /profile loads after the code is checked.
const PREFILL_KEY = 'enroll:prefill';

export interface EnrollPrefill {
  email: string;
  givenName1?: string;
  surnameFirst?: string;
  businessLegalName?: string;
}

export const stashEnrollPrefill = (params: any) => {
  const email = params?.$email;

  if (!email) {
    return;
  }

  const prefill: EnrollPrefill = {
    email,
    givenName1: params.$firstname || undefined,
    surnameFirst: params.$lastname || undefined,
    businessLegalName: params.$company || undefined,
  };

  try {
    sessionStorage.setItem(PREFILL_KEY, JSON.stringify(prefill));
  } catch {
    // storage unavailable: the visitor just types the fields
  }
};

// reads and clears the stash; only returns it when it was left for this email
export const takeEnrollPrefill = (email?: string): EnrollPrefill | null => {
  try {
    const raw = sessionStorage.getItem(PREFILL_KEY);
    sessionStorage.removeItem(PREFILL_KEY);

    if (!raw || !email) {
      return null;
    }

    const prefill: EnrollPrefill = JSON.parse(raw);

    return prefill?.email?.trim().toLowerCase() === email.trim().toLowerCase()
      ? prefill
      : null;
  } catch {
    return null;
  }
};
